export var REQUIRED_MESSAGE = "Muss ausgefüllt werden.";
export var INVALID_EMAIL_MESSAGE = "Ungültige E-Mail Adresse.";
export var AGB_MESSAGE = "Sie müssen die AGB akzeptieren.";
export var PRIVACY_MESSAGE = "Sie müssen den Datenschutzbestimmungen zustimmen.";
export var MISSING_STRIPE_TOKEN = "Ihre Kreditkartendaten konnten nicht verarbeitet werden. Bitte versuchen Sie es erneut.";
export var INVALID_IBAN = "Die angegebene IBAN ist nicht gültig.";
export var INVALID_BIC = "Die angegebene BIC ist nicht gültig.";
